import * as React from "react";

import { SHELL_SWITCH_PX, queryDown } from "@/lib/breakpoints";

function getIsMobile(): boolean {
  if (typeof window === "undefined") return false;
  return window.innerWidth < SHELL_SWITCH_PX;
}

// Initialized synchronously from window.innerWidth on first render — NOT
// `undefined`/`false` by default. An `undefined`-first state here previously
// forced every page load through DesktopAdmin's render/mount path first,
// then flipped to MobileAdmin (or re-confirmed Desktop) once the effect ran,
// causing a real second render/mount pass (and, on the desktop branch, a
// second requireAuth/checkAuth cycle) on every single load. See project340.
export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean>(getIsMobile);

  React.useEffect(() => {
    const mql = window.matchMedia(queryDown(SHELL_SWITCH_PX));
    const onChange = () => {
      setIsMobile(window.innerWidth < SHELL_SWITCH_PX);
    };
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
